import loginBanner from "../assets/splitpos-login-banner.webp";
import loginBanner1024 from "../assets/splitpos-login-banner-1024.webp";
import { preloadImage } from "../utils/preloadImage";

/* The Sign In page's brand image. Shared by SignIn (the <img>) and the
   router (the preload), so both name exactly the same files. */

export const LOGIN_BANNER_SRC = loginBanner; // 1536 x 1024
export const LOGIN_BANNER_SRCSET = `${loginBanner1024} 1024w, ${loginBanner} 1536w`;
export const LOGIN_BANNER_WIDTH = 1536;
export const LOGIN_BANNER_HEIGHT = 1024;

/* The panel is `col-lg-7` (7/12 of the width) and only exists from Bootstrap's
   lg breakpoint up; below it the image is never shown. */
export const LOGIN_BANNER_MEDIA = "(min-width: 992px)";
export const LOGIN_BANNER_SIZES = "58vw";

/* Called when the lazy SignIn chunk starts loading, so the banner downloads
   in parallel with the code instead of after it. Desktop only. */
export const preloadLoginBanner = () =>
  preloadImage(LOGIN_BANNER_SRC, {
    media: LOGIN_BANNER_MEDIA,
    imageSrcSet: LOGIN_BANNER_SRCSET,
    imageSizes: LOGIN_BANNER_SIZES,
  });
